import { useState } from "react"
import axiosInstance from "../connections/axiosInstance"
import { useNavigate } from "react-router-dom"

export default function Login(){
    const [secretKey, setSecretKey] = useState("")
    const navigate = useNavigate()

    const changeHandler = (event) => {
        setSecretKey(event.target.value)
    }

    const submitHandler = async () => {
        const response = await axiosInstance.post("/login", { secret_key: secretKey })

        if (response?.status === 200) {
          navigate("/") 
        }
    }

    return (
        <div className="p-7 flex justify-center flex-col items-center w-full h-screen">
            <input type="text" className="border" onChange={changeHandler} value={secretKey}/>
            <button className="" onClick={submitHandler}>
                SUBMIT
            </button>
        </div>
    )
}